// import SideMenu from "../student/SideMenu";
// import Sidebar from "../../components/dashboard/sidebar";
import SideMenu from "../student/SideMenu";
import DashboardFooter from "../../components/dashboard/footer";
import Footer from "../../pages/Footer";
import DashboardHeader from "../../components/dashboard/header";
import Header from "../../pages/Header";
import LL from "../LL";

const LectureLibrary = () => {
    const token = localStorage.getItem("token");
    return (
        <>
            <div id="layout-wrapper" className="video-player-db">
                {token ? <DashboardHeader /> : <Header />}
                {token && <SideMenu />}
                {token? 
                    <div className="main-content mt-4 user-management lecture-library mt-4" id="main-content">
                        <div className="container-fluid" id="container-fluid">
                            <div className="row table-data" id="table-data-row">
                                <div className="col-12">
                                    <LL />
                                </div>
                            </div>
                        </div>
                    </div>
                    :<div className="landing-page-vid">
                    <div className={`${token ? "main-content mt-4" : " "} user-management lecture-library mt-4`} id="main-content">
                        <div className="container-fluid" id="container-fluid">
                            <div className="row table-data" id="table-data-row">
                                <div className="col-12">
                                    <LL />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>}
               
                {token && <DashboardFooter id="footer" />}
            </div>
            {!token && <Footer id="footer" />}

        </>
    );
};

export default LectureLibrary;